import { useSessionStore } from '@systemeio/util'

const WAITED_STUDENT_PROGRESS_EXPORT_IDS_LOCALE_STORAGE_KEY =
  'WAITED_STUDENT_PROGRESS_EXPORT_IDS_LOCALE_STORAGE_KEY'

export const useWaitedStudentProgressExportIdsStorage = () => {
  const { getItem, setItem, removeItem } = useSessionStore<Set<number>>(
    WAITED_STUDENT_PROGRESS_EXPORT_IDS_LOCALE_STORAGE_KEY,
    {
      parser: value => new Set(JSON.parse(value)),
      stringifier: value => JSON.stringify(Array.from(value)),
    },
  )

  const addExportId = (exportId: number) => {
    const ids = getItem() ?? new Set()
    ids.add(exportId)
    setItem(ids)
  }

  return {
    getItem,
    setItem,
    removeItem,
    addExportId,
  }
}
